import { useState } from "react";
import UpdateEcMember from "./Component/UpdateEcMember";
import UpdateMemberSecretry from "./Component/UpdateMemberSecretery";
import UpdatePresident from "./Component/UpdatePresident";
import ManageMemberDesignation from "./Component/ManageMemberDesignation";

const TABS = [
  { key: "ManageMemberDesignation", label: "Member Designation", component: ManageMemberDesignation },
  { key: "UpdatePresidents",        label: "Update Presidents",  component: UpdatePresident },
  { key: "UpdateMemberSecretry",    label: "Update Secretary",   component: UpdateMemberSecretry },
  { key: "UpdateECMemberSecretry",  label: "Update EC Member",   component: UpdateEcMember },
];

const UpdateDesignation = () => {
  const [activeKey, setActiveKey] = useState("ManageMemberDesignation");

  return (
    <div>
      {/* Custom tab bar */}
      <div style={{ display: "flex", borderBottom: "2px solid #E2E8F0", marginBottom: 24, gap: 0 }}>
        {TABS.map((tab) => {
          const isActive = activeKey === tab.key;
          return (
            <button
              key={tab.key}
              onClick={() => setActiveKey(tab.key)}
              style={{
                padding: "10px 22px",
                fontSize: 13,
                fontWeight: isActive ? 700 : 500,
                color: isActive ? "#fff" : "#718096",
                background: isActive ? "#1B5E20" : "#fff",
                border: "none",
                borderBottom: isActive ? "2px solid #1B5E20" : "2px solid transparent",
                borderRadius: isActive ? "8px 8px 0 0" : "8px 8px 0 0",
                cursor: "pointer",
                transition: "all 0.18s",
                outline: "none",
                marginBottom: -2,
                letterSpacing: 0.1,
              }}
            >
              {tab.label}
            </button>
          );
        })}
      </div>

      {/* Tab content — mountOnEnter/unmountOnExit equivalent: only render active tab */}
      {TABS.map((tab) => {
        if (activeKey !== tab.key) return null;
        const Component = tab.component;
        return (
          <div key={tab.key}>
            <Component />
          </div>
        );
      })}
    </div>
  );
};

export default UpdateDesignation;
